import { createContext } from 'react';

export type User = {
    id: string;
    firstName: string;
    lastName: string;
};

export const UserContext = createContext<User | undefined>(undefined);
